import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import paths from './paths'

Vue.use(VueRouter)

const routes = paths

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.access_token) {
    var { access_token, token_type } = to.query
    store.dispatch('set_token', { access_token, token_type })
    delete to.access_token
    delete to.token_type
  }
  if (!store.getters.isAuthenticated) {
    store.dispatch('init')
  }
  if (!store.getters.isAuthenticated) {
    if (to.matched.some(record => !record.meta.nonRequiresAuth)) {
      next({
        path: '/login',
        query: { 
          callback: window.location.href,
          client_id: store.state.credentials.client_id,
          client_secret: store.state.credentials.client_secret
        }
      })
    } else {
      next()
    }
  }
  else {
    next()
  }
})

export default router
